import { useTranslation } from '@wix/fe-essentials/react';
import { ElementStatus, RuleElement } from '@wix/rules-panel-ui';
import _ from 'lodash';
import React, { useCallback } from 'react';
import { BiCtaNames } from '../../../bi/types';
import { useBiLogger } from '../../../hooks/use-bi-logger';
import { useHandleElementClick } from '../../../hooks/use-handle-element-click';
import { convertBooleanStatusToElementStatus } from '../alt-image-fixer/utils';
import { ColorContrastElementContent } from './color-contrast-element-content/color-contrast-element-content';
import { ColorContrastRuleHeader } from './color-contrast-rule-header';
export const ColorContrastRule = _ref => {
  var _element$label;
  let {
    isOpen,
    toggleElement,
    onClickApply,
    onClickCancel,
    onChangeElementsColor,
    showLoader,
    elementIndex,
    element,
    contentRef,
    headerRef,
    pageId,
    isGeneric
  } = _ref;
  const biLogger = useBiLogger();
  const {
    t
  } = useTranslation();
  const status = element.isValid;
  const onStatusChange = useCallback(() => {
    biLogger.elementStatusChange({
      index: elementIndex,
      status: status ? ElementStatus.Passed : ElementStatus.Failed
    });
  }, [biLogger, elementIndex, status]);
  const {
    handleClickElement
  } = useHandleElementClick({
    isOpen,
    onOpenElement: () => biLogger.taskElementCtaClick({
      ctaName: BiCtaNames.Edit,
      index: elementIndex,
      status: status ? ElementStatus.Passed : ElementStatus.Failed
    }),
    toggleElement
  });
  const headerLabel = !_.isEmpty((_element$label = element.label) == null ? void 0 : _element$label.trim()) ? element.label : t('accessibility-wizard.rules-list.color-contrast.element.header-label.generic');
  return /*#__PURE__*/React.createElement(RuleElement, {
    contentComponent: /*#__PURE__*/React.createElement("div", {
      ref: contentRef
    }, /*#__PURE__*/React.createElement(ColorContrastElementContent, {
      dataHook: isGeneric ? 'generic' : 'regular',
      elementIndex: elementIndex,
      failedElement: element,
      isGeneric: isGeneric,
      pageId: pageId,
      showLoader: showLoader,
      status: status,
      onChangeElementsColor: onChangeElementsColor,
      onClickApply: onClickApply,
      onClickCancel: onClickCancel
    })),
    headerComponent: /*#__PURE__*/React.createElement("div", {
      ref: isOpen ? headerRef : null
    }, /*#__PURE__*/React.createElement(ColorContrastRuleHeader, {
      label: headerLabel
    })),
    iconButtonAriaLabel: t('accessibility-wizard.common.edit.aria-label'),
    iconButtonToolTip: t('accessibility-wizard.common.edit'),
    id: element.elementId,
    isOpen: isOpen,
    status: convertBooleanStatusToElementStatus(status),
    onClick: handleClickElement,
    onStatusChange: onStatusChange
  });
};
//# sourceMappingURL=color-contrast-rule.js.map